import Modal from "components/Modal";
import { CreateWasteLogicRetVal, TWasteSchema } from "./useCreateWasteLogic";
import { FormProvider } from "react-hook-form";
import { ComboBox } from "components/ComboBox";
import { RadioCardGroup } from "components/RadioCardGroup";
import { TextInputFormProvider } from "components/TextInputFormProvider";
import { TextAreaFormProvider } from "components/TextAreaFormProvider";
import { DropdownFormProvider } from "components/DropdownFormProvider";
import Divider from "components/Divider";
import {
  ModalPrimaryButton,
  ModalSecondaryAction,
} from "pages/app/customer/AddFacility/AddFacilityModal";
import { useCreateOrUpdateSeparatorLogic } from "hooks/useCreateOrUpdateSeparatorLogic.hook";
import { AddSeparatorModal } from "pages/app/facility/AddSeparatorModal";
import { useQueryClient } from "@tanstack/react-query";
import { UppdragQueryKey } from "api/uppdrag.api";
import {
  AvskiljareTomningType,
  getAvskiljareTomningTypeLabel,
} from "types/enums";

type Props = {
  logic: CreateWasteLogicRetVal;
  title: string;
  hideSeparatorDropdownIfNoSeparatorPreSelected?: boolean;
};
export const WasteModal = ({
  logic,
  title,
  hideSeparatorDropdownIfNoSeparatorPreSelected,
}: Props) => {
  const queryClient = useQueryClient();

  const addSeparatorLogic = useCreateOrUpdateSeparatorLogic(
    logic.uppdrag.facility,
    () => queryClient.invalidateQueries({ queryKey: [UppdragQueryKey.GetOne] }),
  );

  return (
    <Modal
      isOpen={logic.isModalOpen}
      title={title}
      actionText="Spara"
      onClose={logic.onModalClose}
      afterClose={logic.afterModalClose}
      isLoading={logic.isPending}
      loadingText="Sparar..."
      hideButtons
    >
      <FormProvider {...logic.form}>
        <form className="mt-4 pt-4" onSubmit={logic.onSubmit}>
          {!logic.hideSeparator &&
            (!hideSeparatorDropdownIfNoSeparatorPreSelected ||
              !!logic.selectedSeparator) && (
              <DropdownFormProvider
                items={logic.separatorDropdownItems}
                label="Objekt"
                name="tomningSeparatorUuid"
                action={
                  !logic.isSetSeparatorDisabled
                    ? addSeparatorLogic.openModal
                    : undefined
                }
                actionText={
                  !logic.isSetSeparatorDisabled ? "Nytt objekt" : undefined
                }
                className="mb-6"
                disabled={logic.isSetSeparatorDisabled}
              />
            )}

          {logic.isAvskiljareSelected && (
            <RadioCardGroup<TWasteSchema>
              name="tomningType"
              label="Typ av tömning"
              required
              items={[
                {
                  id: AvskiljareTomningType.Heltomning,
                  label: getAvskiljareTomningTypeLabel(
                    AvskiljareTomningType.Heltomning,
                  ),
                },
                {
                  id: AvskiljareTomningType.Toppsugning,
                  label: getAvskiljareTomningTypeLabel(
                    AvskiljareTomningType.Toppsugning,
                  ),
                },
              ]}
              radioGroupClassName="grid grid-cols-2 gap-x-4"
              className="mb-6"
            />
          )}
          <ComboBox
            label="Avfallskod*"
            items={logic.wasteCodeComboBoxItems}
            setQuery={logic.setWasteCodeQuery}
            selectedItem={logic.selectedWasteCode}
            setSelectedItem={logic.setSelectedWasteCode}
            errorMessage={logic.form.formState.errors.wasteCodeUuid?.message}
            className="mb-6"
          />
          {/* <RadioCardGroup<TWasteSchema>
            name="wasteType"
            label="Enhet"
            required
            items={[
              { id: "Weight", label: "Vikt" },
              { id: "Quantity", label: "Antal" },
            ]}
            radioGroupClassName="grid grid-cols-2 gap-x-4"
          /> */}
          {/* {wasteType === "Weight" && ( */}
          <TextInputFormProvider
            label="Uppskattad vikt"
            name="weightPreliminary"
            appendix="kg"
            customSize="half"
            className="mb-6"
          />
          <TextInputFormProvider
            label="Vägd vikt"
            name="weightFinal"
            appendix="kg"
            customSize="half"
            className="mb-6"
          />
          {/* )} */}
          {/* {wasteType === "Quantity" && (
            <TextInputFormProvider
              label="Antal"
              name="quantity"
              appendix="stycken"
              customSize="half"
            />
          )} */}

          <AddSeparatorModal logic={addSeparatorLogic} />

          <TextAreaFormProvider label="Kommentar" name="comment" rows={2} />

          <Divider className="mb-4 mt-6" />
          <div className="flex items-center gap-x-4">
            <ModalSecondaryAction onClick={logic.onModalClose} />
            <ModalPrimaryButton isLoading={logic.isPending} />
          </div>
        </form>
      </FormProvider>
    </Modal>
  );
};
